import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

import Dashboard from './Dashboard';
import CategoriesList from './Categories/CategoriesList';
import AddCategories from './Categories/AddCategories';
import EditCategory from './Categories/EditCategory';
import SubCategoryList from './SubCategory/SubCategoryList';
import AddSubCategory from './SubCategory/AddSubCategory';
import EditSubCategory from './SubCategory/EditSubCategory';
import PartyMasterList from './PartyMaster/PartyMasterList';
import AddPartyMaster from './PartyMaster/AddPartyMaster';
import EditPartyMaster from './PartyMaster/EditPartyMaster';
import StockAdjustmentsList from './StockAdjustments/StockAdjustmentsList';
import AddStockAdjustment from './StockAdjustments/AddStockAdjustment';
import ContraEntriesList from './ContraEntry/ContraEntriesList';
import AddContraEntry from './ContraEntry/AddContraEntry';
import EditContraEntry from './ContraEntry/EditContraEntry';
import BankPaymentList from './BankPayment/BankPaymentList';
import AddBankPayment from './BankPayment/AddBankPayment';
import EditBankPayment from './BankPayment/EditBankPayment';
import BankReceivedList from './BankReceived/BankReceivedList';
import AddBankReceived from './BankReceived/AddBankReceived';
import EditBankReceived from './BankReceived/EditBankReceived';
import CashPaymentList from './CashPayment/CashPaymentList';
import AddCashReceived from './CashPayment/AddCashReceived';
import EditCashReceived from './CashPayment/EditCashReceived';
import PlatingList from './Plating/PlatingList';
import AddPlating from './Plating/AddPlating';
import EditPlating from './Plating/EditPlating';
import FlashesList from './Flashes/FlashesList';
import AddFlash from './Flashes/AddFlash';
import EditFlash from './Flashes/EditFlash';
import LakersList from './Lakers/LakersList';
import AddLaker from './Lakers/AddLaker';
import EditLaker from './Lakers/EditLaker';
import RodiumsList from './Rodiums/RodiumsList';
import AddRodiums from './Rodiums/AddRodiums';
import EditRodiums from './Rodiums/EditRodiums';
import PurcheshesList from './Purcheshes/PurcheshesList';
import AddPurcheshes from './Purcheshes/AddPurcheshes';
import EditPurchesh from './Purcheshes/EditPurchesh';
import PurcheshReturnsList from './PurcheshReturns/PurcheshReturnsList';
import AddPurcheshReturn from './PurcheshReturns/AddPurcheshReturn';
import EditPurcheshReturn from './PurcheshReturns/EditPurcheshReturn';
import CashReceivedList from './CashReceived/CashReceivedList';
import AddCashReceiveds from './CashReceived/AddCashReceiveds';
import EditCashReceiveds from './CashReceived/EditCashReceiveds';
import QRCodeList from './QRCode/QRCodeList';
import AddQRCode from './QRCode/AddQRCode';
import EditQRCode from './QRCode/EditQRCode';

import FranchisesList from './Franchises/FranchisesList';
import AddFranchise from './Franchises/AddFranchise';
import EditFranchise from './Franchises/EditFranchise';
import LeaveList from './Leave/LeaveList';
import AddLeave from './Leave/AddLeave';
import EditLeave from './Leave/EditLeave';
import TaskList from './Task/TaskList';
import AddTask from './Task/AddTask';
import AddTaskk from './Task/AddTaskk';
import EditTask from './Task/EditTask';
import InWordProductsList from './InWordProducts/InWordProductsList';
import AddInWordProduct from './InWordProducts/AddInWordProduct';
import EditProduct from './InWordProducts/EditProduct';
import TodoList from './Todo/TodoList';
import AddTodo from './Todo/AddTodo';
import EditTodo from './Todo/EditTodo';
import LeadsList from './Leads/LeadsList';
import AddLeads from './Leads/AddLeads';
import EditLead from './Leads/EditLead';
import OutdoorProductList from './OutdoorProduct/OutdoorProductList';
import AddOutdoorProduct from './OutdoorProduct/AddOutdoorProduct';
import EditOutdoorProduct from './OutdoorProduct/EditOutdoorProduct';
import StaffList from './Staff/StaffList';
import AddStaff from './Staff/AddStaff';
import EditStaff from './Staff/EditStaff';
import HolidaysList from './Holidays/HolidaysList';
import AddHoliday from './Holidays/AddHoliday';
import EditHoliday from './Holidays/EditHoliday';
import WalletList from './Wallet/WalletList';
import AddWallet from './Wallet/AddWallet';
import AddsWallet from './Wallet/AddsWallet';
import FineList from './Fine/FineList';
import AddFine from './Fine/AddFine';
import AddsFine from './Fine/AddsFine';

import WatchmenList from './Watchmen/WatchmenList';
import AddWatchman from './Watchmen/AddWatchman';
import EditWatchman from './Watchmen/EditWatchman';
import CustomerList from './Customer/CustomerList';
import AddCustomer from './Customer/AddCustomer';
import ViewCustomer from './Customer/ViewCustomer';
import EditCustomer from './Customer/EditCustomer';
import VisitsList from './Visits/VisitsList';
import AddVisit from './Visits/AddVisit';
import EditVisit from './Visits/EditVisit';
import ViewVisit from './Visits/ViewVisit';
import BazarList from './Bazar/BazarList';
import AddBazar from './Bazar/AddBazar';
import EditBazarWork from './Bazar/EditBazarWork';
import RepairingsList from './Repairings/RepairingsList';
import AddRepairing from './Repairings/AddRepairing';
import EditRepairing from './Repairings/EditRepairing';
import SalesVisitsList from './SalesVisits/SalesVisitsList';
import AddSalesVisit from './SalesVisits/AddSalesVisit';
import EditSalesVisit from './SalesVisits/EditSalesVisit';
import RemindersList from './Reminders/RemindersList';
import AddReminder from './Reminders/AddReminder';
import EditReminder from './Reminders/EditReminder';
import VPList from './VP/VPList';
import AddVP from './VP/AddVP';
import EditVP from './VP/EditVP';
import AddCatalogue from './Catalogue/AddCatalogue';
import CatalogueList from './Catalogue/CatalogueList';
import EditCatalogue from './Catalogue/EditCatalogue';
import GoldCatalogueList from './GoldCatalogue/GoldCatalogueList';
import AddGoldCatalogue from './GoldCatalogue/AddGoldCatalogue';
import EditGoldCatalogue from './GoldCatalogue/EditGoldCatalogue';
import JobworkList from './Jobwork/JobworkList';
import AddJobwork from './Jobwork/AddJobwork';
import EditJobwork from './Jobwork/EditJobwork';
import SafeModuleList from './SafeModule/SafeModuleList';
import AddSafeModule from './SafeModule/AddSafeModule';
import EditSafeModule from './SafeModule/EditSafeModule';
import MeterModuleList from './MeterModule/MeterModuleList';
import AddMeterModule from './MeterModule/AddMeterModule';
import AddMeterModulee from './MeterModule/AddMeterModulee';
import EditMeterModule from './MeterModule/EditMeterModule';
import BillModuleList from './BillModule/BillModuleList';
import AddBill from './BillModule/AddBill';
import SalesStockList from './SalesStock/SalesStockList';
import AddStock from './SalesStock/AddStock';
import StockOut from './SalesStock/StockOut';
import ParcelList from './Parcel/ParcelList';
import AddParcel from './Parcel/AddParcel';
import OfficeStocksList from './OfficeStock/OfficeStocksList';
import AddStockk from './OfficeStock/AddStockk';
import OutStockk from './OfficeStock/OutStockk';
import RawStocksList from './RawStock/RawStocksList';
import AddRawStock from './RawStock/AddRawStock';
import OutRawStock from './RawStock/OutRawStock';
import ReportsList from './Reports/ReportsList';
import AddReport from './Reports/AddReport';
import EditReport from './Reports/EditReport';
import AddLead from './OrderLead/AddLead';
import EditLeads from './OrderLead/EditLeads';
import OrderList from './Orders/OrderList';
import OrderLeadList from './OrderLead/OrderLeadList';
import TodayKarigarDeliveryList from './TodayKarigarDelivery/TodayKarigarDeliveryList';
import TodayDeliveryOrderList from './TodayDeliveryOrder/TodayDeliveryOrderList';
import Header from "./Header";

import Sidebar from './Sidebar';
import Login from './Login';
import Logout from "./Logout";
import ChangePassword from "./ChangePassword"; // only once




function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route
          path="/Dashboard"
          element={
            <>
              {" "}
              <Header />
              <Sidebar />
              <Dashboard />
            </>
          }
        />
        <Route
          path="/CategoriesList"
          element={
            <>
              <Header />
              <Sidebar />
              <CategoriesList />
            </>
          }
        />
        <Route
          path="/ChangePassword"
          element={
            <>
              <Header />
              <Sidebar />
              <ChangePassword />
            </>
          }
        />

        <Route
          path="/AddCategories"
          element={
            <>
              <Header />
              <Sidebar />
              <AddCategories />
            </>
          }
        />
        <Route
          path="/EditCategory/:id"
          element={
            <>
              <Header />
              <Sidebar />
              <EditCategory />
            </>
          }
        />

        <Route
          path="/SubCategoryList"
          element={
            <>
              <Header />
              <Sidebar />
              <SubCategoryList />
            </>
          }
        />
        <Route
          path="/AddSubCategory"
          element={
            <>
              <Header />
              <Sidebar />
              <AddSubCategory />
            </>
          }
        />
        <Route
          path="/EditSubCategory/:id"
          element={
            <>
              <Header />
              <Sidebar />
              <EditSubCategory />
            </>
          }
        />
        <Route
          path="/PartyMasterList"
          element={
            <>
              <Header />
              <Sidebar />
              <PartyMasterList />
            </>
          }
        />
        <Route
          path="/AddPartyMaster"
          element={
            <>
              <Header />
              <Sidebar />
              <AddPartyMaster />
            </>
          }
        />
        <Route
          path="/EditPartyMaster/:id"
          element={
            <>
              <Header />
              <Sidebar />
              <EditPartyMaster />
            </>
          }
        />
        <Route
          path="/StockAdjustmentsList"
          element={
            <>
              <Header />
              <Sidebar />
              <StockAdjustmentsList />
            </>
          }
        />
        <Route
          path="/AddStockAdjustment"
          element={
            <>
              <Header />
              <Sidebar />
              <AddStockAdjustment />
            </>
          }
        />
        <Route
          path="/ContraEntriesList"
          element={
            <>
              <Header />
              <Sidebar />
              <ContraEntriesList />
            </>
          }
        />
        <Route
          path="/EditContraEntry/:id"
          element={
            <>
              <Header />
              <Sidebar />
              <EditContraEntry />
            </>
          }
        />
        <Route
          path="/AddContraEntry"
          element={
            <>
              <Header />
              <Sidebar />
              <AddContraEntry />
            </>
          }
        />
        <Route
          path="/BankPaymentList"
          element={
            <>
              <Sidebar />
              <BankPaymentList />
            </>
          }
        />
        <Route
          path="/AddBankPayment"
          element={
            <>
              <Sidebar />
              <AddBankPayment />
            </>
          }
        />
        <Route
          path="/EditBankPayment/:id"
          element={
            <>
              <Sidebar />
              <EditBankPayment />
            </>
          }
        />
        <Route
          path="/BankReceivedList"
          element={
            <>
              <Sidebar />
              <BankReceivedList />
            </>
          }
        />
        <Route
          path="/AddBankReceived"
          element={
            <>
              <Sidebar />
              <AddBankReceived />
            </>
          }
        />
        <Route
          path="/EditBankReceived/:id"
          element={
            <>
              <Sidebar />
              <EditBankReceived />
            </>
          }
        />
        <Route
          path="/CashPaymentList"
          element={
            <>
              <Sidebar />
              <CashPaymentList />
            </>
          }
        />
        <Route
          path="/AddCashReceived"
          element={
            <>
              <Sidebar />
              <AddCashReceived />
            </>
          }
        />
        <Route
          path="/EditCashReceived/:id"
          element={
            <>
              <Sidebar />
              <EditCashReceived />
            </>
          }
        />
        <Route
          path="/PlatingList"
          element={
            <>
              <Header />
              <Sidebar />
              <PlatingList />
            </>
          }
        />
        <Route
          path="/AddPlating"
          element={
            <>
              <Sidebar />
              <AddPlating />
            </>
          }
        />
        <Route
          path="/EditPlating/:id"
          element={
            <>
              <Sidebar />
              <EditPlating />
            </>
          }
        />
        <Route
          path="/FlashesList"
          element={
            <>
              <Sidebar />
              <FlashesList />
            </>
          }
        />
        <Route
          path="/AddFlash"
          element={
            <>
              <Sidebar />
              <AddFlash />
            </>
          }
        />
        <Route
          path="/EditFlash/:id"
          element={
            <>
              <Sidebar />
              <EditFlash />
            </>
          }
        />
        <Route
          path="/LakersList"
          element={
            <>
              <Sidebar />
              <LakersList />
            </>
          }
        />
        <Route
          path="/AddLaker"
          element={
            <>
              <Sidebar />
              <AddLaker />
            </>
          }
        />
        <Route
          path="/EditLaker/:id"
          element={
            <>
              <Sidebar />
              <EditLaker />
            </>
          }
        />
        <Route
          path="/RodiumsList"
          element={
            <>
              <Sidebar />
              <RodiumsList />
            </>
          }
        />
        <Route
          path="/AddRodiums"
          element={
            <>
              <Sidebar />
              <AddRodiums />
            </>
          }
        />
        <Route
          path="/EditRodiums/:id"
          element={
            <>
              <Sidebar />
              <EditRodiums />
            </>
          }
        />
        <Route
          path="/PurcheshesList"
          element={
            <>
              <Sidebar />
              <PurcheshesList />
            </>
          }
        />
        <Route
          path="/AddPurcheshes"
          element={
            <>
              <Sidebar />
              <AddPurcheshes />
            </>
          }
        />
        <Route
          path="/EditPurchesh/:id"
          element={
            <>
              <Sidebar />
              <EditPurchesh />
            </>
          }
        />
        <Route
          path="/PurcheshReturnsList"
          element={
            <>
              <Sidebar />
              <PurcheshReturnsList />
            </>
          }
        />
        <Route
          path="/AddPurcheshReturn"
          element={
            <>
              <Sidebar />
              <AddPurcheshReturn />
            </>
          }
        />
        <Route
          path="/EditPurcheshReturn/:id"
          element={
            <>
              <Sidebar />
              <EditPurcheshReturn />
            </>
          }
        />
        <Route
          path="/CashReceivedList"
          element={
            <>
              <Sidebar />
              <CashReceivedList />
            </>
          }
        />
        <Route
          path="/AddCashReceiveds"
          element={
            <>
              <Sidebar />
              <AddCashReceiveds />
            </>
          }
        />
        <Route
          path="/EditCashReceiveds/:id"
          element={
            <>
              <Sidebar />
              <EditCashReceiveds />
            </>
          }
        />
        <Route
          path="/QRCodeList"
          element={
            <>
              <Sidebar />
              <QRCodeList />
            </>
          }
        />
        <Route
          path="/AddQRCode"
          element={
            <>
              <Sidebar />
              <AddQRCode />
            </>
          }
        />
        <Route
          path="/EditQRCode/:id"
          element={
            <>
              <Sidebar />
              <EditQRCode />
            </>
          }
        />

        <Route
          path="/FranchisesList"
          element={
            <>
              <Sidebar />
              <FranchisesList />
            </>
          }
        />
        <Route
          path="/OrderLeadList"
          element={
            <>
              <Header />
              <Sidebar />
              <OrderLeadList />
            </>
          }
        />
        <Route
          path="/AddFranchise"
          element={
            <>
              <Sidebar />
              <AddFranchise />
            </>
          }
        />
        <Route
          path="/EditFranchise/:id"
          element={
            <>
              <Sidebar />
              <EditFranchise />
            </>
          }
        />
        <Route
          path="/LeaveList"
          element={
            <>
              <Header />
              <Sidebar />
              <LeaveList />
            </>
          }
        />
        <Route
          path="/AddLeave"
          element={
            <>
              <Sidebar />
              <AddLeave />
            </>
          }
        />
        <Route
          path="/EditLeave/:id"
          element={
            <>
              <Sidebar />
              <EditLeave />
            </>
          }
        />
        <Route
          path="/TaskList"
          element={
            <>
              <Header />
              <Sidebar />
              <TaskList />
            </>
          }
        />
        <Route
          path="/AddTask"
          element={
            <>
              <Header />
              <Sidebar />
              <AddTask />
            </>
          }
        />
        <Route
          path="/AddTaskk"
          element={
            <>
              <Header />
              <Sidebar />
              <AddTaskk />
            </>
          }
        />
        <Route
          path="/EditTask/:id"
          element={
            <>
              <Header />
              <Sidebar />
              <EditTask />
            </>
          }
        />
        <Route
          path="/InWordProductsList"
          element={
            <>
              <Header />
              <Sidebar />
              <InWordProductsList />
            </>
          }
        />
        <Route
          path="/AddInWordProduct"
          element={
            <>
              <Header />
              <Sidebar />
              <AddInWordProduct />
            </>
          }
        />
        <Route
          path="/TodoList"
          element={
            <>
              <Header />
              <Sidebar />
              <TodoList />
            </>
          }
        />
        <Route
          path="/AddTodo"
          element={
            <>
              <Header />
              <Sidebar />
              <AddTodo />
            </>
          }
        />
        <Route
          path="/EditTodo/:id"
          element={
            <>
              <Header />
              <Sidebar />
              <EditTodo />
            </>
          }
        />
        <Route
          path="/LeadsList"
          element={
            <>
              <Header />
              <Sidebar />
              <LeadsList />
            </>
          }
        />
        <Route
          path="/AddLeads"
          element={
            <>
              <Header />
              <Sidebar />
              <AddLeads />
            </>
          }
        />
        <Route
          path="/EditLead/:id"
          element={
            <>
              <Header />
              <Sidebar />
              <EditLead />
            </>
          }
        />
        <Route
          path="/OutdoorProductList"
          element={
            <>
              <Header />
              <Sidebar />
              <OutdoorProductList />
            </>
          }
        />
        <Route
          path="/AddOutdoorProduct"
          element={
            <>
              <Header />
              <Sidebar />
              <AddOutdoorProduct />
            </>
          }
        />
        <Route
          path="/EditOutdoorProduct/:id"
          element={
            <>
              <Header />
              <Sidebar />
              <EditOutdoorProduct />
            </>
          }
        />
        <Route
          path="/StaffList"
          element={
            <>
              <Header />
              <Sidebar />
              <StaffList />
            </>
          }
        />
        <Route
          path="/AddStaff"
          element={
            <>
              <Header />
              <Sidebar />
              <AddStaff />
            </>
          }
        />
        <Route
          path="/EditStaff/:id"
          element={
            <>
              <Header />
              <Sidebar />
              <EditStaff />
            </>
          }
        />
        <Route
          path="/HolidaysList"
          element={
            <>
              <Header />
              <Sidebar />
              <HolidaysList />
            </>
          }
        />
        <Route
          path="/AddHoliday"
          element={
            <>
              <Header />
              <Sidebar />
              <AddHoliday />
            </>
          }
        />
        <Route
          path="/EditHoliday/:id"
          element={
            <>
              <Header />
              <Sidebar />
              <EditHoliday />
            </>
          }
        />
        <Route
          path="/EditProduct/:id"
          element={
            <>
              <Header />
              <Sidebar />
              <EditProduct />
            </>
          }
        />
        <Route
          path="/WalletList"
          element={
            <>
              <Header />
              <Sidebar />
              <WalletList />
            </>
          }
        />
        <Route
          path="/AddWallet"
          element={
            <>
              <Header />
              <Sidebar />
              <AddWallet />
            </>
          }
        />
        <Route
          path="/AddsWallet"
          element={
            <>
              <Header />
              <Sidebar />
              <AddsWallet />
            </>
          }
        />
        <Route
          path="/FineList"
          element={
            <>
              <Header />
              <Sidebar />
              <FineList />
            </>
          }
        />
        <Route
          path="/AddFine"
          element={
            <>
              <Header />
              <Sidebar />
              <AddFine />
            </>
          }
        />
        <Route
          path="/AddsFine"
          element={
            <>
              <Header />
              <Sidebar />
              <AddsFine />
            </>
          }
        />
        <Route
          path="/WatchmenList"
          element={
            <>
              <Header />
              <Sidebar />
              <WatchmenList />
            </>
          }
        />
        <Route
          path="/AddWatchman"
          element={
            <>
              <Header />
              <Sidebar />
              <AddWatchman />
            </>
          }
        />
        <Route
          path="/EditWatchman/:id"
          element={
            <>
              <Header />
              <Sidebar />
              <EditWatchman />
            </>
          }
        />
        <Route
          path="/CustomerList"
          element={
            <>
              <Header />
              <Sidebar />
              <CustomerList />
            </>
          }
        />
        <Route
          path="/AddCustomer"
          element={
            <>
              <Header />
              <Sidebar />
              <AddCustomer />
            </>
          }
        />
        <Route
          path="/EditCustomer/:id"
          element={
            <>
              <Header />
              <Sidebar />
              <EditCustomer />
            </>
          }
        />
        <Route
          path="/VisitsList"
          element={
            <>
              <Header />
              <Sidebar />
              <VisitsList />
            </>
          }
        />
        <Route
          path="/AddVisit"
          element={
            <>
              <Header />
              <Sidebar />
              <AddVisit />
            </>
          }
        />
        <Route
          path="/EditVisit/:id"
          element={
            <>
              <Header />
              <Sidebar />
              <EditVisit />
            </>
          }
        />
        <Route
          path="/ViewVisit/:id"
          element={
            <>
              <Header />
              <Sidebar />
              <ViewVisit />
            </>
          }
        />
        <Route
          path="/BazarList"
          element={
            <>
              <Header />
              <Sidebar />
              <BazarList />
            </>
          }
        />
        <Route
          path="/AddBazar"
          element={
            <>
              <Header />
              <Sidebar />
              <AddBazar />
            </>
          }
        />
        <Route
          path="/EditBazarWork/:id"
          element={
            <>
              <Header />
              <Sidebar />
              <EditBazarWork />
            </>
          }
        />
        <Route
          path="/RepairingsList"
          element={
            <>
              <Header />
              <Sidebar />
              <RepairingsList />
            </>
          }
        />
        <Route
          path="/AddRepairing"
          element={
            <>
              <Header />
              <Sidebar />
              <AddRepairing />
            </>
          }
        />
        <Route
          path="/EditRepairing/:id"
          element={
            <>
              <Header />
              <Sidebar />
              <EditRepairing />
            </>
          }
        />
        <Route
          path="/ViewCustomer/:id"
          element={
            <>
              <Header />
              <Sidebar />
              <ViewCustomer />
            </>
          }
        />
        <Route
          path="/SalesVisitsList"
          element={
            <>
              <Header />
              <Sidebar />
              <SalesVisitsList />
            </>
          }
        />
        <Route
          path="/AddSalesVisit"
          element={
            <>
              <Header />
              <Sidebar />
              <AddSalesVisit />
            </>
          }
        />
        <Route
          path="/EditSalesVisit/:id"
          element={
            <>
              <Header />
              <Sidebar />
              <EditSalesVisit />
            </>
          }
        />
        <Route
          path="/RemindersList"
          element={
            <>
              <Header />
              <Sidebar />
              <RemindersList />
            </>
          }
        />
        <Route
          path="/AddReminder"
          element={
            <>
              <Header />
              <Sidebar />
              <AddReminder />
            </>
          }
        />
        <Route
          path="/EditReminder/:id"
          element={
            <>
              <Header />
              <Sidebar />
              <EditReminder />
            </>
          }
        />
        <Route
          path="/VPList"
          element={
            <>
              <Header />
              <Sidebar />
              <VPList />
            </>
          }
        />
        <Route
          path="/AddVP"
          element={
            <>
              <Header />
              <Sidebar />
              <AddVP />
            </>
          }
        />
        <Route
          path="/EditVP/:id"
          element={
            <>
              <Header />
              <Sidebar />
              <EditVP />
            </>
          }
        />
        <Route
          path="/AddCatalogue"
          element={
            <>
              <Header />
              <Sidebar />
              <AddCatalogue />
            </>
          }
        />
        <Route
          path="/CatalogueList"
          element={
            <>
              <Header />
              <Sidebar />
              <CatalogueList />
            </>
          }
        />
        <Route
          path="/EditCatalogue/:id"
          element={
            <>
              <Header />
              <Sidebar />
              <EditCatalogue />
            </>
          }
        />
        <Route
          path="/GoldCatalogueList"
          element={
            <>
              <Header />
              <Sidebar />
              <GoldCatalogueList />
            </>
          }
        />
        <Route
          path="/AddGoldCatalogue"
          element={
            <>
              <Header />
              <Sidebar />
              <AddGoldCatalogue />
            </>
          }
        />
        <Route
          path="/EditGoldCatalogue/:id"
          element={
            <>
              <Header />
              <Sidebar />
              <EditGoldCatalogue />
            </>
          }
        />
        <Route
          path="/JobworkList"
          element={
            <>
              <Header />
              <Sidebar />
              <JobworkList />
            </>
          }
        />
        <Route
          path="/AddJobwork"
          element={
            <>
              <Header />
              <Sidebar />
              <AddJobwork />
            </>
          }
        />
        <Route
          path="/EditJobwork/:id"
          element={
            <>
              <Header />
              <Sidebar />
              <EditJobwork />
            </>
          }
        />
        <Route
          path="/SafeModuleList"
          element={
            <>
              <Header />
              <Sidebar />
              <SafeModuleList />
            </>
          }
        />
        <Route
          path="/AddSafeModule"
          element={
            <>
              <Header />
              <Sidebar />
              <AddSafeModule />
            </>
          }
        />
        <Route
          path="/EditSafeModule/:id"
          element={
            <>
              <Header />
              <Sidebar />
              <EditSafeModule />
            </>
          }
        />
        <Route
          path="/MeterModuleList"
          element={
            <>
              <Header />
              <Sidebar />
              <MeterModuleList />
            </>
          }
        />
        <Route
          path="/AddMeterModule"
          element={
            <>
              <Header />
              <Sidebar />
              <AddMeterModule />
            </>
          }
        />
        <Route
          path="/AddMeterModulee"
          element={
            <>
              <Header />
              <Sidebar />
              <AddMeterModulee />
            </>
          }
        />
        <Route
          path="/EditMeterModule/:id"
          element={
            <>
              <Header />
              <Sidebar />
              <EditMeterModule />
            </>
          }
        />
        <Route
          path="/BillModuleList"
          element={
            <>
              <Header />
              <Sidebar />
              <BillModuleList />
            </>
          }
        />
        <Route
          path="/AddBill"
          element={
            <>
              <Header />
              <Sidebar />
              <AddBill />
            </>
          }
        />
        <Route
          path="/SalesStockList"
          element={
            <>
              <Header />
              <Sidebar />
              <SalesStockList />
            </>
          }
        />
        <Route
          path="/AddStock"
          element={
            <>
              <Header />
              <Sidebar />
              <AddStock />
            </>
          }
        />
        <Route
          path="/StockOut"
          element={
            <>
              <Header />
              <Sidebar />
              <StockOut />
            </>
          }
        />
        <Route
          path="/ParcelList"
          element={
            <>
              <Header />
              <Sidebar />
              <ParcelList />
            </>
          }
        />
        <Route
          path="/AddParcel"
          element={
            <>
              <Header />
              <Sidebar />
              <AddParcel />
            </>
          }
        />
        <Route
          path="/OfficeStocksList"
          element={
            <>
              <Header />
              <Sidebar />
              <OfficeStocksList />
            </>
          }
        />
        <Route
          path="/AddStockk"
          element={
            <>
              <Header />
              <Sidebar />
              <AddStockk />
            </>
          }
        />
        <Route
          path="/RawStocksList"
          element={
            <>
              <Header />
              <Sidebar />
              <RawStocksList />
            </>
          }
        />
        <Route
          path="/OutStockk"
          element={
            <>
              <Header />
              <Sidebar />
              <OutStockk />
            </>
          }
        />
        <Route
          path="/AddRawStock"
          element={
            <>
              <Header />
              <Sidebar />
              <AddRawStock />
            </>
          }
        />
        <Route
          path="/OutRawStock"
          element={
            <>
              <Header />
              <Sidebar />
              <OutRawStock />
            </>
          }
        />
        <Route
          path="/ReportsList"
          element={
            <>
              <Header />
              <Sidebar />
              <ReportsList />
            </>
          }
        />
        <Route
          path="/AddReport"
          element={
            <>
              <Header />
              <Sidebar />
              <AddReport />
            </>
          }
        />
        <Route
          path="/EditReport/:id"
          element={
            <>
              <Header />
              <Sidebar />
              <EditReport />
            </>
          }
        />
        <Route
          path="/AddLead"
          element={
            <>
              <Header />
              <Sidebar />
              <AddLead />
            </>
          }
        />
        <Route
          path="/EditLeads/:id"
          element={
            <>
              <Header />
              <Sidebar />
              <EditLeads />
            </>
          }
        />
        <Route
          path="/OrderList"
          element={
            <>
              <Header />
              <Sidebar />
              <OrderList />
            </>
          }
        />
        <Route
          path="/TodayKarigarDeliveryList"
          element={
            <>
              <Header />
              <Sidebar />
              <TodayKarigarDeliveryList />
            </>
          }
        />
        <Route
          path="/TodayDeliveryOrderList"
          element={
            <>
              <Header />
              <Sidebar />
              <TodayDeliveryOrderList />
            </>
          }
        />
        <Route path="/Logout" element={<Logout />} />
      </Routes>
    </Router>
  );
}

export default App;
